// src/components/ProfileModal.js
import React, { useState } from 'react';
import './ProfileModal.css';
import apiService from '../services/api';
import Snackbar from './Snackbar';

const ProfileModal = ({ isOpen, onClose }) => {
  

  // Extract all values from sessionStorage
  const userName = sessionStorage.getItem('user_name') || 'John Doe';
  const userEmail = sessionStorage.getItem('user_emailId') || 'user@example.com';
  const userId = sessionStorage.getItem('user_id') || userEmail;
  const jobTitle = sessionStorage.getItem('job_title') || 'Employee';
  const department = sessionStorage.getItem('user_department') || 'Unknown Department';
  const accessRole = sessionStorage.getItem('access_role') || 'user';
  const mobile = sessionStorage.getItem('mobile_phone') || 'Not Available';
  const officeLocation = sessionStorage.getItem('office_location') || 'CriticalRiver Technologies Pvt Ltd';
  const managerName = sessionStorage.getItem('manager_name') || 'Not Assigned';
  const managerEmail = sessionStorage.getItem('manager_email') || 'Not Available';
  const userRole = sessionStorage.getItem('user_role') || jobTitle;
  const [snackbar, setSnackbar] = useState({
  message: "",
  type: "success",
  isOpen: false,
});

const showSnackbar = (message, type = "success") => {
  setSnackbar({ message, type, isOpen: true });
};
  
  // Get image URL from sessionStorage
  const imageUrl = sessionStorage.getItem('image_url');
  const getInitials = (name) => {
    const names = name.split(' ');
    if (names.length >= 2) {
      return (names[0][0] + names[names.length - 1][0]).toUpperCase();
    }
    return names[0][0].toUpperCase();
  };
  const userInitials = getInitials(userName);
  const [profileImage, setProfileImage] = useState(
    imageUrl || `https://ui-avatars.com/api/?name=${userInitials}&background=6366f1&color=fff&size=200&bold=true`
  );


  if (!isOpen) return null;

const handleImageChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  // Instant preview
  const previewUrl = URL.createObjectURL(file);
  setProfileImage(previewUrl);

  const formData = new FormData();
  formData.append("email", userEmail);
  formData.append("image", file);

  try {
    const response = await apiService.uploadProfileImage(formData);

    if (response.status === "success") {
      sessionStorage.setItem("image_url", response.image_url);
      setProfileImage(response.image_url);

     window.dispatchEvent(new Event("profile-updated"));
      showSnackbar("Profile image updated successfully!", "success");
    } else {
     
      showSnackbar(response.message || "Failed to upload profile image.", "error");
    }
  } catch (error) {
    console.error("Upload error:", error);

   
    showSnackbar("Server error while uploading profile image.", "error");
  }
};


  


  return (
    <>
      {/* Blur Background Overlay */}
      <div className="profile-modal-overlay" onClick={onClose}></div>

      {/* Modal Container */}
      <div className="profile-modal-container">
        <div className="profile-modal-wrapper">
          {/* Header Bar */}
          <div className="modal-header-bar">
            <div className="modal-header-left">
              <h2 className="modal-header-title">Employee Profile</h2>
            </div>
            <button className="modal-close-button" onClick={onClose}>
              <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Profile Header Section */}
          <div className="profile-header-section">
            <div className="profile-header-content">
              <div className="profile-image-container">
                <img src={profileImage} alt="Profile" className="profile-image" />
                <label htmlFor="profile-upload" className="profile-edit-button" title="Change profile picture">
                  <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                  </svg>
                  <input 
                    id="profile-upload" 
                    type="file" 
                    accept="image/*" 
                    onChange={handleImageChange} 
                    className="profile-upload-input" 
                  />
                </label>
              </div>
              <div className="profile-header-info">
                <h3 className="profile-name">{userName}</h3>
                {/* <p className="profile-job-title">{jobTitle}</p> */}
                <div className="profile-badges">
                  <span className="badge badge-role">{accessRole.toUpperCase()}</span>
                  <span className="badge badge-department">{department}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Content Sections */}
          <div className="profile-content-sections">
            {/* Contact Information */}
            <div className="info-section">
              <div className="profile-section-header">
                <h4 className="section-title">CONTACT INFORMATION</h4>
              </div>
              <div className="info-grid">
                <div className="info-field">
                  <p className="info-label">EMAIL ADDRESS</p>
                  <p className="info-value">{userEmail}</p>
                </div>
                {/* <div className="info-field">
                  <p className="info-label">USER ID</p>
                  <p className="info-value">{userId}</p>
                </div> */}
                <div className="info-field">
                  <p className="info-label">MOBILE PHONE</p>
                  <p className="info-value">{mobile}</p>
                </div>
                <div className="info-field">
                  <p className="info-label">OFFICE LOCATION</p>
                  <p className="info-value">{officeLocation}</p>
                </div>
              </div>
            </div>

            {/* Work Information */}
            <div className="info-section">
              <div className="profile-section-header">
                {/* <div className="section-icon section-icon-work">
                  <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div> */}
                <h4 className="section-title">WORK INFORMATION</h4>
              </div>
              <div className="info-grid">
                <div className="info-field">
                  <p className="info-label">JOB TITLE</p>
                  <p className="info-value">{jobTitle}</p>
                </div>
                {/* <div className="info-field">
                  <p className="info-label">USER ROLE</p>
                  <p className="info-value">{userRole}</p>
                </div> */}
                <div className="info-field">
                  <p className="info-label">DEPARTMENT</p>
                  <p className="info-value">{department}</p>
                </div>
                <div className="info-field">
                  <p className="info-label">ACCESS LEVEL</p>
                  <p className="info-value">
                    {accessRole === 'admin' ? 'Administrator' : 
                     accessRole === 'manager' ? 'Manager' : 'User'}
                  </p>
                </div>
              </div>
            </div>

            {/* Manager Information */}
            <div className="info-section">
              <div className="profile-section-header">
                {/* <div className="section-icon section-icon-manager">
                  <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div> */}
                <h4 className="section-title">MANAGER INFORMATION</h4>
              </div>
              <div className="info-grid">
                <div className="info-field">
                  <p className="info-label">MANAGER NAME</p>
                  <p className="info-value">{managerName}</p>
                </div>
                <div className="info-field">
                  <p className="info-label">MANAGER EMAIL</p>
                  <p className="info-value">{managerEmail}</p>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            {/* <div className="modal-actions">
              <button className="btn-primary" onClick={handleEditProfile}>
                Edit Profile
              </button>
              <button className="btn-secondary" onClick={onClose}>
                Close
              </button>
            </div> */}
          </div>
        </div>
      </div>
      {snackbar.isOpen && (
  <Snackbar
    message={snackbar.message}
    type={snackbar.type}
    duration={3000}
    onClose={() => setSnackbar((prev) => ({ ...prev, isOpen: false }))}
  />
)}

    </>
  );
};

export default ProfileModal;